import { NICmsContentField } from '@icms/core/content';
import { NICmsContentPageType } from '@icms/core/content/interfaces/icms-content-page-type.interfaces';
import { BLOG_TAB, NCmsBlogRoot } from './cms-blog-root.interface';

export const CMS_BLOG_ROOT_CONFIG = <NICmsContentPageType.IMeta>{
    id: NCmsBlogRoot.typeId,
    title: 'Blog root',
    fields: [
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.tagRedirect',
            title: 'Redirect location on tag change',
            default: true,
            tab: BLOG_TAB
        },
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'Component',
            default: []
        }
    ],
    initData: {
        components: []
    }
};
